/* istanbul ignore file */
import * as moment from "moment";

export default {
  IMAGE_CROP: process.env.REACT_APP_FEATURE_IMAGE_CROP !== "off",
  DATA_HOOK: process.env.REACT_APP_FEATURE_DATA_HOOK === "on",
  BRAZE: process.env.REACT_APP_FEATURE_BRAZE === "on",
  AUTO_UPGRADE: process.env.REACT_APP_FEATURE_AUTO_UPGRADE === "on",
  AREA_CONDO_SPECIALIST:
    process.env.REACT_APP_FEATURE_AREA_CONDO_SPECIALIST === "on",
  GEO_REDEMPTION: process.env.REACT_APP_FEATURE_GEO_REDEMPTION === "on",
  CROSS_LISTING: process.env.REACT_APP_FEATURE_CROSS_LISTING === "on",
  PAYMENT_GATEWAY: process.env.REACT_APP_FEATURE_PAYMENT_GATEWAY === "on",
  SHOW_BRICKZ_ACCESS_EXPIRE_DATE:
    process.env.REACT_APP_FEATURE_SHOW_BRICKZ_ACCESS_EXPIRE_DATE === "on",
  DYNAMIC_PRICING: process.env.REACT_APP_FEATURE_DYNAMIC_PRICING === "on",
  DOWNLOAD_LISTING_PDF:
    process.env.REACT_APP_FEATURE_DOWNLOAD_LISTING_PDF === "on",

  /* NOTE: 9 Dec 2022, ICUST-8527 watermark feature turned ON ==> OFF */
  WATERMARK: process.env.REACT_APP_FEATURE_WATERMARK === "on",
  AGENT_NET_REPORTING:
    process.env.REACT_APP_FEATURE_AGENT_NET_REPORTING === "on",
  EARLY_UPGRADE: process.env.REACT_APP_FEATURE_EARLY_UPGRADE === "on",
  AREA_CONDO_SPECIALIST_SELF_SERVE:
    process.env.REACT_APP_FEATURE_AREA_CONDO_SPECIALIST_SELF_SERVE === "on",
  LEAD_MANAGEMENT: process.env.REACT_APP_FEATURE_LEAD_MANAGEMENT_V2 === "on",
  LEAD_MANAGEMENT_V2_75:
    process.env.REACT_APP_FEATURE_LEAD_MANAGEMENT_V2_75 === "on",
  LEAD_MANAGEMENT_EVENT_BRIDGE_FETCH_SSE:
    process.env.REACT_APP_FEATURE_LEAD_MANAGEMENT_EVENT_BRIDGE_FETCH_SSE ===
    "on",
  PRISM_V2: moment().isAfter(process.env.REACT_APP_FEATURE_PRISM_V2_START),
  CL_VALIDATION: process.env.REACT_APP_FEATURE_CL_VALIDATION === "on",
  LSOT: process.env.REACT_APP_FEATURE_LSOT === "on",
  REPRICING: process.env.REACT_APP_FEATURE_REPRICING === "on",
  REPRICING_BLOCK_SELF_SERVE: false,
  PRISIM_V2_5: moment().isAfter(process.env.REACT_APP_FEATURE_PRISM_V2_5_START),
  MARKET_WATCH: moment().isAfter(
    process.env.REACT_APP_FEATURE_MARKET_WATCH_START
  ),
  LISTING_CREATION_V3:
    process.env.REACT_APP_FEATURE_LISTING_CREATION_V3 === "on",
  LCV3_FULL_ROLLOUT: moment().isAfter(
    process.env.REACT_APP_FEATURE_LCV3_FULL_ROLLOUT
  ),
  AD_PRODUCT_HARMONIZATION: moment().isAfter(
    process.env.REACT_APP_FEATURE_AD_PRODUCT_HARMONIZATION_START
  ),
  SUNSET_PAYMENT_HISTORY_PAGE: moment().isAfter(
    process.env.REACT_APP_FEATURE_SUNSET_PAYMENT_HISTORY_PAGE
  ),
  ENABLE_VA_IPP: process.env.REACT_APP_ENABLE_VA_IPP === "on",
  VERIFIED_AGENT_BANNER:
    process.env.REACT_APP_FEATURE_VERIFIED_AGENT_BANNER === "on",
  SUNSET_AC_SPECIALIST_BOOKING: moment().isAfter(
    process.env.REACT_APP_FEATURE_SUNSET_AC_SPECIALIST_BOOKING
  ),
  SUNSET_AC_SPECIALIST_REDEEM: moment().isAfter(
    process.env.REACT_APP_FEATURE_SUNSET_AC_SPECIALIST_REDEEM
  ),
};
